module.exports = __webpack_public_path__ + "img/5-low.2e2d6288.jpg";